import React, { useState, useEffect, useRef } from "react"
import { Col, Row } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin"
import { getCashCounts, getSales } from "../../Helpers/apiCalls/reportsAPI"
import Table from "../../Components/TableTemplate/Table"
import {
  formatDateNoTime,
  getRole,
  numberFormat,
} from "../../Helpers/Utils/Common"
import { Navigate } from "react-router-dom"
import { CSVLink } from "react-csv"
import { useReactToPrint } from "react-to-print"
import ExportPDF from "../../Components/Export/ExportPDF"
import PrintReportReceipts from "../../Components/Print/PrintReportReceipts"
import { DownloadTableExcel } from "react-export-table-to-excel"
import MytFooter from "../../Components/MytFooter"


function CashCounts() {
  const navigate = useNavigate()
  const componentRef = useRef()
  const [inactive, setInactive] = useState(true)
  const [cashCounts, setCashCounts] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [readyExport, setReadyExport] = useState(false)
  const [exportData, setExportData] = useState([])
  const [overAllSales, setOverAllSales] = useState(0)
  const [overAllInitialDrawer, setOverAllInitialDrawer] = useState(0)
  const [expectedCount, setExpectedCount] = useState(0)
  const [allOverage, setAllOverrage] = useState(0)

  const exportHeaders = [
    { label: "Date", key: "count_date" },
    { label: "Cashier", key: "added_by" },
    { label: "Initial Drawer", key: "initial_drawer" },
    { label: "Expected Count", key: "expected_count" },
    { label: "Physical Count", key: "physical_count" },
    { label: "Over/Short", key: "overage" },
    { label: "Total", key: "physical_count" },
  ]

  const headers = [
    "Date",
    "Cashier",
    "Initial Drawer",
    "Expected Count",
    "Physical Count",
    "Over/Short",
    "Total",
  ]

  async function fetchCashCounts() {
    setShowLoader(true)
    const response = await getCashCounts()
    setShowLoader(false)
    if (response.data) {
      var arr = []
      response.data.message.cash_counts !== null &&
        response.data.message.cash_counts.map((data) => {
          arr.push({
            ...data,
            count_date: formatDateNoTime(new Date(data.count_date)),
            initial_drawer: numberFormat(data.initial_drawer),
            expected_count: numberFormat(data.expected_count),
            physical_count: numberFormat(data.physical_count),
            overage: numberFormat(data.overage),
          })
          setOverAllSales(
            response.data.message.cash_counts
              .map((data) => parseFloat(data.physical_count))
              .reduce((a, b) => a + b, 0)
              .toFixed(2)
          )
          setOverAllInitialDrawer(
            response.data.message.cash_counts
              .map((data) => parseFloat(data.initial_drawer))
              .reduce((a, b) => a + b, 0)
              .toFixed(2)
          )
          setExpectedCount(
            response.data.message.cash_counts
              .map((data) => parseFloat(data.expected_count))
              .reduce((a, b) => a + b, 0)
              .toFixed(2)
          )
          setAllOverrage(
            response.data.message.cash_counts
              .map((data) => parseFloat(data.overage))
              .reduce((a, b) => a + b, 0)
              .toFixed(2)
          )
        })

      const result =
        response.data.message.cash_counts !== null &&
        response.data.message.cash_counts.map((data) => {
          return {
            count_date: data.count_date,
            added_by: data.added_by,
            initial_drawer: data.initial_drawer,
            expected_count: data.expected_count,
            physical_count: data.physical_count,
            overage: data.overage,
          }
        })

      setExportData(result.length === 0 ? [] : result)
      setReadyExport(true)
      setCashCounts(arr)
    } else {
      setCashCounts([])
    }
  }

  /** EXPORT */
  function handleToCSV() {
    if (readyExport) {
      return (
        <DownloadTableExcel
          filename="Report Summary"
          sheet="users"
          currentTableRef={componentRef.current}
        >
          <button className="category-new-export-btn">Export to CSV</button>
        </DownloadTableExcel>
      )
    }
  }

  const componentRefSummary = useRef()
  const handlePrintReport = useReactToPrint({
    content: () => componentRefSummary.current,
    pageStyle: () => "@page { size: letter; margin: 5mm; }",
  })

  function handlePDF() {
    if (readyExport) {
      if (getRole() !== "1") {
        return <ExportPDF name={"Sales"} data={exportData} header={headers} />
      } else {
        return (
          <button
            className="category-new-export-btn"
            onClick={handlePrintReport}
          >
            Export to PDF
          </button>
        )
      }
    }
  }

  useEffect(() => {
    fetchCashCounts()
  }, [])

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm btn-warning rounded"
        id={row.id}
        onClick={() => navigate("/cash-counts-report/view/" + row.id)}
      >
        View
      </button>
    )
  }

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive)
        }}
        active={"Reports"} //Dashboard navbar index
        page={"Reports"}
      />
      <div
        className={`container ps-5 pt-4 bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col xl={6}>
            <h1 className="page-title-menu"> CASH COUNTS REPORT</h1>
          </Col>
          <Col xl={3}></Col>
          <Col xl={3}>
            {cashCounts.length > 0 && (
              <Row>
                <Col>
                  <div className="d-flex justify-content-end">
                    {handleToCSV()}
                  </div>
                </Col>
                <Col>
                  <div className="d-flex justify-content-end">
                    {handlePDF()}
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <hr />
        <div className="table-content">
          {/* TABLE */}
          <Table
            tableHeaders={[
              "DATE",
              "CASHIER",
              // "INITIAL DRAWER",
              "EXPECTED CNT.",
              "PHYSICAL CNT.",
              "OVER / SHORT",
            ]}
            headerSelector={[
              "count_date",
              "added_by",
              // "initial_drawer",
              "expected_count",
              "physical_count",
              "overage",
            ]}
            tableData={cashCounts}
            showLoader={showLoader}
            PendingBtn={(row) => ViewBtn(row)}
          />
        </div>

        <div style={{ display: "none" }}>
          <PrintReportReceipts
            ref={componentRefSummary}
            name={"Cash Counts Report"}
            data={cashCounts}
          />
        </div>
        <div style={{ display: "none" }}>
          <Row>
            <div className="row" ref={componentRef}>
            <Row>
                <Col className="text-center print-text">
                  <label>{window.company_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_address1}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_address2}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_min}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_sn}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_ptu_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <table className="table table-bordered left ms-5 ">
                <thead></thead>
                <tbody>
                  <tr>
                    <th colSpan={3}>CASH COUNT REPORTS</th>
                  </tr>
                  <tr>
                    <th>DATE</th>
                    <th>CASHIER</th>
                    <th>INITIAL DRAWER</th>
                    <th>EXPECTED COUNT</th>
                    <th>PHYSICAL COUNT</th>
                    <th>OVER/SHORT</th>
                  </tr>
                  {cashCounts.map((data) => {
                    return (
                      <tr>
                        <td>{data.added_on} </td>
                        <td>{data.added_by}</td>
                        <td>{data.initial_drawer} </td>
                        <td>{data.expected_count} </td>
                        <td>{data.physical_count} </td>
                        <td>{data.overage} </td>
                      </tr>
                    )
                  })}
                  <tr>
                    <br></br>
                  </tr>
                  <tr>
                    <td> </td>
                    <td></td>
                    <td>
                      {numberFormat(
                        parseFloat(overAllInitialDrawer).toFixed(2)
                      )}{" "}
                    </td>
                    <td>
                      {numberFormat(parseFloat(expectedCount).toFixed(2))}{" "}
                    </td>
                    <td>
                      {numberFormat(parseFloat(overAllSales).toFixed(2))}{" "}
                    </td>
                    <td>{numberFormat(parseFloat(allOverage).toFixed(2))} </td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </Row>
        </div>
      </div>
      <MytFooter/>
    </div>
  )
}

export default CashCounts
